export const cPhoneIntlInput = {
    initialCountry: 'gt',
    separateDialCode: true,
    formatOnDisplay: false, 
    allowEmpty: true,
    codigoPais: '+502'
  }